// removed by extract-text-webpack-plugin
module.exports = {"container":"_3rBHlJVtI3sk769bL5puMF","content":"snv-fkoTTdhlyfg8OABPn","warningMessage":"_223_NMQ-zzm-lwYwz0heny","close":"BsdrDWpqA8dm6NuwJq7JC","warning_icon":"_3OAjenFy-MBI5k8evMk-rb","image_container":"_1AQffEMdRPva_pQOIAY-G","text_container":"xl1bzHBrO8YGkrFQIcytw"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/MaintenanceNotification/MaintenanceNotification.css
// module id = 1081
// module chunks = 58